/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * API
 * OpenAPI contract generated from Nest application
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CheckMintPaymentDto,
  CheckMintPaymentResponseDto,
  ConfirmMintDto,
  CreateMintOrderDto,
  CreateMintOrderResponseDto,
  MintOrderResponseDto,
  PrepareMintDto,
  RefreshDto,
  TelegramAuthDto,
  TelemintControllerConfirmMint200,
  TelemintControllerDebugMintParams,
  TelemintControllerGetMintPrice200,
  TelemintControllerGetMyGift200,
  TelemintControllerPrepareMint200,
  TokenPairDto,
  UpdateUserDto
} from './model';

import customFetcher from '../api/orval-fetcher';
type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Creates an idempotent mint order and returns the exact TEP-74 USDT transfer for the connected MAINNET wallet.
 * @summary Create an exact-price custodial USDT mint order
 */
export const telemintControllerCreateMintOrder = (
    createMintOrderDto: CreateMintOrderDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<CreateMintOrderResponseDto>(
      {url: `/api/telemint/mint-orders`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createMintOrderDto, signal
    },
      options);
    }



export const getTelemintControllerCreateMintOrderMutationOptions = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>, TError,{data: CreateMintOrderDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>, TError,{data: CreateMintOrderDto}, TContext> => {

const mutationKey = ['telemintControllerCreateMintOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>, {data: CreateMintOrderDto}> = (props) => {
          const {data} = props ?? {};

          return  telemintControllerCreateMintOrder(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type TelemintControllerCreateMintOrderMutationResult = NonNullable<Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>>
    export type TelemintControllerCreateMintOrderMutationBody = CreateMintOrderDto
    export type TelemintControllerCreateMintOrderMutationError = void | void

    /**
 * @summary Create an exact-price custodial USDT mint order
 */
export const useTelemintControllerCreateMintOrder = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>, TError,{data: CreateMintOrderDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof telemintControllerCreateMintOrder>>,
        TError,
        {data: CreateMintOrderDto},
        TContext
      > => {

      const mutationOptions = getTelemintControllerCreateMintOrderMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Returns the current custodial payment, mint, and reconciliation status for an order owned by the authenticated user.
 * @summary Get a custodial mint order owned by the user
 */
export const telemintControllerGetMintOrder = (
    id: string,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<MintOrderResponseDto>(
      {url: `/api/telemint/mint-orders/${id}`, method: 'GET', signal
    },
      options);
    }




export const getTelemintControllerGetMintOrderQueryKey = (id?: string,) => {
    return [
    `/api/telemint/mint-orders/${id}`
    ] as const;
    }


export const getTelemintControllerGetMintOrderQueryOptions = <TData = Awaited<ReturnType<typeof telemintControllerGetMintOrder>>, TError = void>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintOrder>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemintControllerGetMintOrderQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemintControllerGetMintOrder>>> = ({ signal }) => telemintControllerGetMintOrder(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintOrder>>, TError, TData> & { queryKey: QueryKey }
}

export type TelemintControllerGetMintOrderQueryResult = NonNullable<Awaited<ReturnType<typeof telemintControllerGetMintOrder>>>
export type TelemintControllerGetMintOrderQueryError = void


/**
 * @summary Get a custodial mint order owned by the user
 */

export function useTelemintControllerGetMintOrder<TData = Awaited<ReturnType<typeof telemintControllerGetMintOrder>>, TError = void>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintOrder>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTelemintControllerGetMintOrderQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Checks the authenticated user's exact wallet attempt. Pending includes successful transfers awaiting deposit indexing and all inconclusive results.
 * @summary Check a signed mint payment for a confirmed on-chain failure
 */
export const telemintControllerCheckMintPayment = (
    id: string,
    checkMintPaymentDto: CheckMintPaymentDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<CheckMintPaymentResponseDto>(
      {url: `/api/telemint/mint-orders/${id}/payment-check`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: checkMintPaymentDto, signal
    },
      options);
    }



export const getTelemintControllerCheckMintPaymentMutationOptions = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>, TError,{id: string;data: CheckMintPaymentDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>, TError,{id: string;data: CheckMintPaymentDto}, TContext> => {

const mutationKey = ['telemintControllerCheckMintPayment'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>, {id: string;data: CheckMintPaymentDto}> = (props) => {
          const {id,data} = props ?? {};

          return  telemintControllerCheckMintPayment(id,data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type TelemintControllerCheckMintPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>>
    export type TelemintControllerCheckMintPaymentMutationBody = CheckMintPaymentDto
    export type TelemintControllerCheckMintPaymentMutationError = void | void

    /**
 * @summary Check a signed mint payment for a confirmed on-chain failure
 */
export const useTelemintControllerCheckMintPayment = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>, TError,{id: string;data: CheckMintPaymentDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof telemintControllerCheckMintPayment>>,
        TError,
        {id: string;data: CheckMintPaymentDto},
        TContext
      > => {

      const mutationOptions = getTelemintControllerCheckMintPaymentMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Generates a signed message for minting an NFT number from the pool. Returns the signed message that the user needs to send to the blockchain.
 * @summary Prepare mint message
 */
export const telemintControllerPrepareMint = (
    prepareMintDto: PrepareMintDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TelemintControllerPrepareMint200>(
      {url: `/api/telemint/prepare`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: prepareMintDto, signal
    },
      options);
    }



export const getTelemintControllerPrepareMintMutationOptions = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerPrepareMint>>, TError,{data: PrepareMintDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof telemintControllerPrepareMint>>, TError,{data: PrepareMintDto}, TContext> => {

const mutationKey = ['telemintControllerPrepareMint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof telemintControllerPrepareMint>>, {data: PrepareMintDto}> = (props) => {
          const {data} = props ?? {};

          return  telemintControllerPrepareMint(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type TelemintControllerPrepareMintMutationResult = NonNullable<Awaited<ReturnType<typeof telemintControllerPrepareMint>>>
    export type TelemintControllerPrepareMintMutationBody = PrepareMintDto
    export type TelemintControllerPrepareMintMutationError = void | void

    /**
 * @summary Prepare mint message
 */
export const useTelemintControllerPrepareMint = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerPrepareMint>>, TError,{data: PrepareMintDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof telemintControllerPrepareMint>>,
        TError,
        {data: PrepareMintDto},
        TContext
      > => {

      const mutationOptions = getTelemintControllerPrepareMintMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Confirms that a mint transaction was successfully executed on the blockchain. Links the NFT to the phone number.
 * @summary Confirm mint transaction
 */
export const telemintControllerConfirmMint = (
    confirmMintDto: ConfirmMintDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TelemintControllerConfirmMint200>(
      {url: `/api/telemint/confirm`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: confirmMintDto, signal
    },
      options);
    }



export const getTelemintControllerConfirmMintMutationOptions = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerConfirmMint>>, TError,{data: ConfirmMintDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof telemintControllerConfirmMint>>, TError,{data: ConfirmMintDto}, TContext> => {

const mutationKey = ['telemintControllerConfirmMint'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof telemintControllerConfirmMint>>, {data: ConfirmMintDto}> = (props) => {
          const {data} = props ?? {};

          return  telemintControllerConfirmMint(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type TelemintControllerConfirmMintMutationResult = NonNullable<Awaited<ReturnType<typeof telemintControllerConfirmMint>>>
    export type TelemintControllerConfirmMintMutationBody = ConfirmMintDto
    export type TelemintControllerConfirmMintMutationError = void | void

    /**
 * @summary Confirm mint transaction
 */
export const useTelemintControllerConfirmMint = <TError = void | void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof telemintControllerConfirmMint>>, TError,{data: ConfirmMintDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof telemintControllerConfirmMint>>,
        TError,
        {data: ConfirmMintDto},
        TContext
      > => {

      const mutationOptions = getTelemintControllerConfirmMintMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Returns the gifted MSISDN reserved for the authenticated user, or null.
 * @summary Get the gift number reserved for the current user
 */
export const telemintControllerGetMyGift = (

 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TelemintControllerGetMyGift200>(
      {url: `/api/telemint/gift`, method: 'GET', signal
    },
      options);
    }




export const getTelemintControllerGetMyGiftQueryKey = () => {
    return [
    `/api/telemint/gift`
    ] as const;
    }


export const getTelemintControllerGetMyGiftQueryOptions = <TData = Awaited<ReturnType<typeof telemintControllerGetMyGift>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMyGift>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemintControllerGetMyGiftQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemintControllerGetMyGift>>> = ({ signal }) => telemintControllerGetMyGift(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMyGift>>, TError, TData> & { queryKey: QueryKey }
}

export type TelemintControllerGetMyGiftQueryResult = NonNullable<Awaited<ReturnType<typeof telemintControllerGetMyGift>>>
export type TelemintControllerGetMyGiftQueryError = unknown


/**
 * @summary Get the gift number reserved for the current user
 */

export function useTelemintControllerGetMyGift<TData = Awaited<ReturnType<typeof telemintControllerGetMyGift>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMyGift>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTelemintControllerGetMyGiftQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the fixed custodial mint price in exact USDT units.
 * @summary Get current mint price
 */
export const telemintControllerGetMintPrice = (

 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TelemintControllerGetMintPrice200>(
      {url: `/api/telemint/mint-price`, method: 'GET', signal
    },
      options);
    }




export const getTelemintControllerGetMintPriceQueryKey = () => {
    return [
    `/api/telemint/mint-price`
    ] as const;
    }


export const getTelemintControllerGetMintPriceQueryOptions = <TData = Awaited<ReturnType<typeof telemintControllerGetMintPrice>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintPrice>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemintControllerGetMintPriceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemintControllerGetMintPrice>>> = ({ signal }) => telemintControllerGetMintPrice(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintPrice>>, TError, TData> & { queryKey: QueryKey }
}

export type TelemintControllerGetMintPriceQueryResult = NonNullable<Awaited<ReturnType<typeof telemintControllerGetMintPrice>>>
export type TelemintControllerGetMintPriceQueryError = unknown


/**
 * @summary Get current mint price
 */

export function useTelemintControllerGetMintPrice<TData = Awaited<ReturnType<typeof telemintControllerGetMintPrice>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerGetMintPrice>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTelemintControllerGetMintPriceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Checks mint transaction, NFT item address, and wallet state. Useful for debugging mint issues.
 * @summary Debug mint transaction
 */
export const telemintControllerDebugMint = (
    params: TelemintControllerDebugMintParams,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<void>(
      {url: `/api/telemint/debug/mint`, method: 'GET',
        params, signal
    },
      options);
    }




export const getTelemintControllerDebugMintQueryKey = (params?: TelemintControllerDebugMintParams,) => {
    return [
    `/api/telemint/debug/mint`, ...(params ? [params]: [])
    ] as const;
    }


export const getTelemintControllerDebugMintQueryOptions = <TData = Awaited<ReturnType<typeof telemintControllerDebugMint>>, TError = unknown>(params: TelemintControllerDebugMintParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerDebugMint>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTelemintControllerDebugMintQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof telemintControllerDebugMint>>> = ({ signal }) => telemintControllerDebugMint(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof telemintControllerDebugMint>>, TError, TData> & { queryKey: QueryKey }
}

export type TelemintControllerDebugMintQueryResult = NonNullable<Awaited<ReturnType<typeof telemintControllerDebugMint>>>
export type TelemintControllerDebugMintQueryError = unknown


/**
 * @summary Debug mint transaction
 */

export function useTelemintControllerDebugMint<TData = Awaited<ReturnType<typeof telemintControllerDebugMint>>, TError = unknown>(
 params: TelemintControllerDebugMintParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof telemintControllerDebugMint>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getTelemintControllerDebugMintQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Validates the initData hash provided by Telegram and issues a fresh access/refresh token pair.
 * @summary Authenticate via Telegram initData
 */
export const authControllerTelegramAuth = (
    telegramAuthDto: TelegramAuthDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TokenPairDto>(
      {url: `/api/auth/telegram`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: telegramAuthDto, signal
    },
      options);
    }



export const getAuthControllerTelegramAuthMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerTelegramAuth>>, TError,{data: TelegramAuthDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerTelegramAuth>>, TError,{data: TelegramAuthDto}, TContext> => {

const mutationKey = ['authControllerTelegramAuth'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerTelegramAuth>>, {data: TelegramAuthDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerTelegramAuth(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerTelegramAuthMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerTelegramAuth>>>
    export type AuthControllerTelegramAuthMutationBody = TelegramAuthDto
    export type AuthControllerTelegramAuthMutationError = unknown

    /**
 * @summary Authenticate via Telegram initData
 */
export const useAuthControllerTelegramAuth = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerTelegramAuth>>, TError,{data: TelegramAuthDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof authControllerTelegramAuth>>,
        TError,
        {data: TelegramAuthDto},
        TContext
      > => {

      const mutationOptions = getAuthControllerTelegramAuthMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Verifies the provided refresh token and returns a new access/refresh pair when valid.
 * @summary Refresh access token
 */
export const authControllerRefresh = (
    refreshDto: RefreshDto,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<TokenPairDto>(
      {url: `/api/auth/refresh`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: refreshDto, signal
    },
      options);
    }



export const getAuthControllerRefreshMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshDto}, TContext> => {

const mutationKey = ['authControllerRefresh'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerRefresh>>, {data: RefreshDto}> = (props) => {
          const {data} = props ?? {};

          return  authControllerRefresh(data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerRefreshMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerRefresh>>>
    export type AuthControllerRefreshMutationBody = RefreshDto
    export type AuthControllerRefreshMutationError = unknown

    /**
 * @summary Refresh access token
 */
export const useAuthControllerRefresh = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerRefresh>>, TError,{data: RefreshDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof authControllerRefresh>>,
        TError,
        {data: RefreshDto},
        TContext
      > => {

      const mutationOptions = getAuthControllerRefreshMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Revokes the stored refresh token for the authenticated user, effectively ending the session.
 * @summary Logout and revoke refresh token
 */
export const authControllerLogout = (

 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<void>(
      {url: `/api/auth/logout`, method: 'POST', signal
    },
      options);
    }



export const getAuthControllerLogoutMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError,void, TContext> => {

const mutationKey = ['authControllerLogout'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authControllerLogout>>, void> = () => {


          return  authControllerLogout(requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type AuthControllerLogoutMutationResult = NonNullable<Awaited<ReturnType<typeof authControllerLogout>>>

    export type AuthControllerLogoutMutationError = unknown

    /**
 * @summary Logout and revoke refresh token
 */
export const useAuthControllerLogout = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authControllerLogout>>, TError,void, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof authControllerLogout>>,
        TError,
        void,
        TContext
      > => {

      const mutationOptions = getAuthControllerLogoutMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Returns a pageless list of users visible to the current session.
 * @summary List users
 */
export const userControllerFindAll = (

 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<void>(
      {url: `/api/users`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerFindAllQueryKey = () => {
    return [
    `/api/users`
    ] as const;
    }


export const getUserControllerFindAllQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindAll>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerFindAllQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindAll>>> = ({ signal }) => userControllerFindAll(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData> & { queryKey: QueryKey }
}

export type UserControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindAll>>>
export type UserControllerFindAllQueryError = unknown


/**
 * @summary List users
 */

export function useUserControllerFindAll<TData = Awaited<ReturnType<typeof userControllerFindAll>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserControllerFindAllQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Retrieves public metadata for the specified user if it exists.
 * @summary Get user by id
 */
export const userControllerFindOne = (
    id: string,
 options?: SecondParameter<typeof customFetcher>,signal?: AbortSignal
) => {


      return customFetcher<void>(
      {url: `/api/users/${id}`, method: 'GET', signal
    },
      options);
    }




export const getUserControllerFindOneQueryKey = (id?: string,) => {
    return [
    `/api/users/${id}`
    ] as const;
    }


export const getUserControllerFindOneQueryOptions = <TData = Awaited<ReturnType<typeof userControllerFindOne>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getUserControllerFindOneQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindOne>>> = ({ signal }) => userControllerFindOne(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData> & { queryKey: QueryKey }
}

export type UserControllerFindOneQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindOne>>>
export type UserControllerFindOneQueryError = unknown


/**
 * @summary Get user by id
 */

export function useUserControllerFindOne<TData = Awaited<ReturnType<typeof userControllerFindOne>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof userControllerFindOne>>, TError, TData>, request?: SecondParameter<typeof customFetcher>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getUserControllerFindOneQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates profile fields for the authenticated user. Only self-updates are allowed.
 * @summary Update current user
 */
export const userControllerUpdate = (
    id: string,
    updateUserDto: UpdateUserDto,
 options?: SecondParameter<typeof customFetcher>,) => {


      return customFetcher<void>(
      {url: `/api/users/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateUserDto
    },
      options);
    }



export const getUserControllerUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{id: string;data: UpdateUserDto}, TContext> => {

const mutationKey = ['userControllerUpdate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerUpdate>>, {id: string;data: UpdateUserDto}> = (props) => {
          const {id,data} = props ?? {};

          return  userControllerUpdate(id,data,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type UserControllerUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerUpdate>>>
    export type UserControllerUpdateMutationBody = UpdateUserDto
    export type UserControllerUpdateMutationError = unknown

    /**
 * @summary Update current user
 */
export const useUserControllerUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerUpdate>>, TError,{id: string;data: UpdateUserDto}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof userControllerUpdate>>,
        TError,
        {id: string;data: UpdateUserDto},
        TContext
      > => {

      const mutationOptions = getUserControllerUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }

/**
 * Deletes the authenticated user account and revokes related session data.
 * @summary Delete current user
 */
export const userControllerRemove = (
    id: string,
 options?: SecondParameter<typeof customFetcher>,) => {


      return customFetcher<void>(
      {url: `/api/users/${id}`, method: 'DELETE'
    },
      options);
    }



export const getUserControllerRemoveMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetcher>}
): UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,{id: string}, TContext> => {

const mutationKey = ['userControllerRemove'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof userControllerRemove>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  userControllerRemove(id,requestOptions)
        }




  return  { mutationFn, ...mutationOptions }}

    export type UserControllerRemoveMutationResult = NonNullable<Awaited<ReturnType<typeof userControllerRemove>>>

    export type UserControllerRemoveMutationError = unknown

    /**
 * @summary Delete current user
 */
export const useUserControllerRemove = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof userControllerRemove>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customFetcher>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof userControllerRemove>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getUserControllerRemoveMutationOptions(options);

      return useMutation(mutationOptions);
    }
